import * as Api from '@ViewModels';
import { useQuery } from '@tanstack/react-query';
import { useUserSession } from '../../models/hooks/appStateHooks';
import { LevStandardQueryMeta, reactQueryClient } from '../../web/ReactQueryProvider';

const BASE_QUERY_KEY = 'reports/campaign/<id>/group';

export function useCampaignGroupStatsQuery({
	campaignId,
	enabled = true,
	meta,
}: {
	campaignId: string;
	enabled?: boolean;
	meta?: LevStandardQueryMeta;
}) {
	const userSession = useUserSession();
	return useQuery({
		queryFn: () =>
			userSession.webServiceHelper.callAsync<Api.ICampaignGroup>(
				`reports/campaign/${encodeURIComponent(campaignId)}/group`,
				'GET'
			),
		queryKey: [BASE_QUERY_KEY, campaignId],
		enabled: enabled && !!campaignId,
		// Read once to seed the follow-up composer; a background refetch would never reach it.
		staleTime: Infinity,
		refetchOnWindowFocus: false,
		meta,
	});
}

export function invalidateCampaignGroupStatsQueries({ campaignId }: { campaignId?: string } = {}) {
	return reactQueryClient.invalidateQueries({
		queryKey: campaignId ? [BASE_QUERY_KEY, campaignId] : [BASE_QUERY_KEY],
	});
}
